// extracted by mini-css-extract-plugin
module.exports = {"description":"AvatarDescription_description__3K7z7","name":"AvatarDescription_name__1GXJD","rol":"AvatarDescription_rol__2MwcM"};